export const CREATE_PRODUCT2143 = "CREATE_PRODUCT2143";
export const UPDATE_PRODUCT2143 = "UPDATE_PRODUCT2143";
export const DELETE_PRODUCT2143 = "DELETE_PRODUCT2143";
export const FETCH_PRODUCT2143 = "FETCH_PRODUCT2143";
export const LISTEN_TO_SELECTED_PRODUCT2143 = "LISTEN_TO_SELECTED_PRODUCT2143";
export const FILTER_PRODUCT21433 = "FILTER_PRODUCT2143";
